import React from "react";
import {
  DialogTitle,
  DialogContentText,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import { GitBranch, X } from "react-feather";
import ModalLayout from "./Layout";
import ModalLayoutContent from "./Layout/Content";
import ModalLayoutFooter from "./Layout/Footer";
import ModalLayoutBtn from "./Layout/Btn";

/**
 *
 * @param {{
 *  isShown: boolean;
 *  onHide: () => void;
 *  onAction: () => void;
 * }} data
 */
const ByPassTestsModal = ({
  isShown,
  onHide,
  onAction,
  isDarkMode = false,
}) => {
  return (
    <ModalLayout
      isShown={isShown}
      onHide={onHide}
      styles={{
        zIndex: 2002,
        "& .MuiPaper-root": {
          borderRadius: "12px",
          boxShadow: isDarkMode ? "0 10px 30px rgba(0,0,0,0.5)" : "0 10px 30px rgba(0,0,0,0.15)",
          overflow: "hidden",
          background: isDarkMode ? "#252526" : "linear-gradient(to bottom, #ffffff, #f8f9fa)",
          border: isDarkMode ? "1px solid #3c3c3c" : "1px solid rgba(0,0,0,0.08)",
          transition: "all 0.3s ease-in-out"
        }
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        position={"relative"}
        padding={"16px 24px"}
        borderBottom={isDarkMode ? "1px solid #3c3c3c" : "1px solid rgba(0,0,0,0.05)"}
        sx={{ background: isDarkMode ? "rgba(230,57,70,0.15)" : "rgba(255,237,237,0.6)" }}
      >
        <DialogTitle
          padding={"0 !important"}
          sx={{
            color: "#e63946",
            fontWeight: 800,
            fontSize: "11px",
            display: "flex",
            alignItems: "center",
            "::before": {
              content: '""',
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#e63946",
              marginRight: "10px",
              animation: "pulse 1.5s infinite",
              "@keyframes pulse": {
                "0%": { boxShadow: "0 0 0 0 rgba(230, 57, 70, 0.7)" },
                "70%": { boxShadow: "0 0 0 10px rgba(230, 57, 70, 0)" },
                "100%": { boxShadow: "0 0 0 0 rgba(230, 57, 70, 0)" }
              }
            }
          }}
        >
          Warning!
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onHide}
          sx={{
            position: "absolute",
            right: 16,
            top: 10,
            color: isDarkMode ? "#cccccc" : "#495057",
            "&:hover": {
              background: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
              transform: "rotate(90deg)",
              transition: "transform 0.3s ease"
            }
          }}
        >
          <X size={16} />
        </IconButton>
      </Stack>
      <ModalLayoutContent sx={{ padding: "24px 28px" }}>
        <DialogContentText
          textAlign={"center"}
          color={isDarkMode ? "#cccccc" : "#4a4a4a"}
          sx={{ fontSize: "11px", lineHeight: 1.6 }}
        >
          You are about to{" "}
          <Typography
            component={"span"}
            fontWeight={700}
            sx={{
              fontSize: "11px",
              color: isDarkMode ? "#9cdcfe" : "#1d3557",
              background: isDarkMode ? "rgba(156,220,254,0.15)" : "rgba(241,250,255,0.8)",
              padding: "2px 6px",
              borderRadius: "4px",
              border: isDarkMode ? "1px solid rgba(156,220,254,0.3)" : "1px solid rgba(0,123,255,0.2)"
            }}
          >
            bypass tests
          </Typography>{" "}
          which may impact your production DAGs.
          <Typography
            component={"span"}
            fontWeight={700}
            display={"block"}
            fontSize={"11px"}
            sx={{
              color: isDarkMode ? "#f48771" : "#721c24",
              background: isDarkMode ? "rgba(244,135,113,0.15)" : "rgba(248,215,218,0.5)",
              margin: "16px auto 0",
              padding: "10px 12px",
              borderRadius: "6px",
              border: isDarkMode ? "1px dashed rgba(244,135,113,0.4)" : "1px dashed rgba(220,53,69,0.3)",
              maxWidth: "90%",
              animation: "fadeIn 1.1s ease-in",
              "@keyframes fadeIn": {
                "0%": { opacity: 0, transform: "translateY(-5px)" },
                "50%": { opacity: 0.5, transform: "translateY(-5px)" },
                "100%": { opacity: 1, transform: "translateY(0)" }
              }
            }}
          >
            Are you sure?
          </Typography>
        </DialogContentText>
      </ModalLayoutContent>
      <ModalLayoutFooter sx={{ padding: "16px 24px", gap: "12px" }}>
        <ModalLayoutBtn
          color="default"
          onClick={onHide}
          sx={{
            fontSize: "11px",
            borderRadius: "8px",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "none",
            transition: "all 0.2s",
            padding: "8px 16px",
            color: isDarkMode ? "#cccccc" : "#5a6268",
            background: isDarkMode ? "#3c3c3c" : "linear-gradient(45deg, #f5f5f5, #e9ecef)",
            border: isDarkMode ? "1px solid #4a4a4a" : "1px solid #dee2e6",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: isDarkMode ? "0 4px 8px rgba(0,0,0,0.3)" : "0 4px 8px rgba(0,0,0,0.1)",
              background: isDarkMode ? "#4a4a4a" : "linear-gradient(45deg, #e9ecef, #dee2e6)",
            }
          }}
        >
          <X size={16} style={{ marginRight: "6px" }} /> No
        </ModalLayoutBtn>
        <ModalLayoutBtn
          color="error"
          onClick={onAction}
          sx={{
            fontSize: "11px",
            borderRadius: "8px",
            fontWeight: 600,
            textTransform: "none",
            padding: "8px 20px",
            transition: "all 0.2s",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 8px rgba(211,47,47,0.25)"
            }
          }}
        >
          <GitBranch size={16} style={{ marginRight: "6px" }} />
          Yes, bypass
        </ModalLayoutBtn>
      </ModalLayoutFooter>
    </ModalLayout>
  );
};

export default ByPassTestsModal;
